module.exports = __webpack_public_path__ + "static/media/T2-01.20d5c55e.svg";